import * as CONST from './const'

/**
 * Login user
 * @param username
 * @param password
 * @returns Object
 */
export function userLogin(username, password) {
  return {
    type: CONST.AUTH_LOGIN,
    payload: {
      username: username,
      password: password,
    },
  }
}

/**
 * Login user using oAuth2
 * @param username
 * @returns Object
 */
export function userLoginOAuth2(username) {
  return {
    type: CONST.AUTH_LOGIN_OAUTH2,
    payload: {
      username: username,
    },
  }
}

/**
 * Logout user
 *
 * @returns Object
 */
export function userLogout() {
  return {
    type: CONST.AUTH_LOGOUT,
  }
}

/**
 * Request reset password
 *
 * @param email
 * @returns Object
 */
export function requestResetPassword(email) {
  return {
    type: CONST.AUTH_REQUEST_RESET_PASSWORD,
    payload: {
      email: email,
    },
  }
}

/**
 * Check code and hash for password resetting
 *
 * @param {string} code
 * @param {string} hash
 * @returns Object
 */
export function checkCodeAndHashValidForResettingPassword(code, hash) {
  return {
    type: CONST.AUTH_CHECK_CODE_AND_HASH,
    payload: {
      code: code,
      hash: hash,
    },
  }
}

/**
 * Set new password
 *
 * @param hash
 * @param code
 * @param password
 * @returns Object
 */
export function resetPassword(hash, code, password) {
  return {
    type: CONST.AUTH_RESET_PASSWORD,
    payload: {
      code: code,
      hash: hash,
      password: password,
    },
  }
}

/**
 * Init forgot password form
 *
 * @returns Object
 */
export function initForgotPasswordForm() {
  return {
    type: CONST.AUTH_INIT_FORGOT_PASSWORD_FORM,
  }
}
